import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import {SVG} from '@svgdotjs/svg.js';
import {instrument} from 'soundfont-player';

window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collapse').forEach(collapseElement => {
        new Collapse(collapseElement, {
            toggle: false,
        });
    });

    document.querySelectorAll('.dropdown-toggle').forEach(dropdownToggle => {
        new Dropdown(dropdownToggle, {
            toggle: false,
        });
    });
});

/* eslint-disable max-len */

function getMidiNoteForSemitone(semitone) {
    return semitone + 40;
}

// eslint-disable-next-line no-unused-vars
export function drawFretRange(id, shape) {
    'use strict';

    let spaceBetweenFrets = 30;
    let spaceBetweenStrings = 30;
    let stringSidePadding = 10;
    let fretBoardTopPadding = shape.firstStringPositions[0] > 0 ? 10 : 0;

    let fretBoardBottomPadding = 10;

    let playedNotesTextSize = 12;
    let playedNotesPadding = 3;
    let playedNotesHeight = shape.isChord ? (2 * playedNotesPadding + playedNotesTextSize) : 0;

    let stringNotes = 'EADGBE'.split('');
    let stringNoteHeight = 2 * playedNotesPadding + playedNotesTextSize;

    let stringHeight = shape.firstStringPositions.length * spaceBetweenFrets + fretBoardTopPadding + fretBoardBottomPadding;
    let height = stringHeight + playedNotesHeight + stringNoteHeight;
    let stringCount = 6;
    let fretBoardWidth = (stringCount - 1) * spaceBetweenStrings + 2 * stringSidePadding;
    let fretTextSize = 12;
    let fretHeight = 3;
    let noteRadius = 8;
    let noteTextSize = 10;

    let fretLabelWidth = 20;
    let width = fretBoardWidth + fretLabelWidth;

// Ernie Ball Regular Slinky
    let stringWidths = [10, 13, 17, 26, 36, 46].reverse();
    let maxStringWidth = 2;
    let stringWidthCoefficient = maxStringWidth / Math.max.apply(null, stringWidths);

    if (shape.isHorizontal) {
        stringNotes = stringNotes.reverse();
    }

    let svg = SVG().addTo(id);
    let draw = svg.width(shape.isHorizontal ? height : '100%').viewbox(0, 0, shape.isHorizontal ? height : width, shape.isHorizontal ? width : height);

    for (const [index, stringNote] of Object.entries(stringNotes)) {
        let circleCenterX = fretLabelWidth + stringSidePadding + spaceBetweenStrings * index;
        let circleCenterY = stringNoteHeight / 2;

        draw.plain(stringNote).fill('black').attr({
            'x': shape.isHorizontal ? circleCenterY : circleCenterX,
            'y': shape.isHorizontal ? circleCenterX : circleCenterY,
            'dominant-baseline': 'central',
            'text-anchor': 'middle',
        }).font({
            size: playedNotesTextSize,
            family: '',
        });
    }

    let group = draw.group().translate(shape.isHorizontal ? stringNoteHeight : 0, shape.isHorizontal ? 0 : stringNoteHeight);

    let relativeFretIndex = 0;
    shape.firstStringPositions.forEach(function (absoluteFretIndex) {
        let circleCenterX = fretLabelWidth / 2;
        let circleCenterY = fretBoardTopPadding + spaceBetweenFrets * (relativeFretIndex + 0.5);

        group.plain(absoluteFretIndex).fill('black').attr({
            'x': shape.isHorizontal ? circleCenterY : circleCenterX,
            'y': shape.isHorizontal ? circleCenterX : circleCenterY,
            'dominant-baseline': 'central',
            'text-anchor': 'middle',
        }).font({
            size: fretTextSize,
            family: '',
        });

        ++relativeFretIndex;
    });

    let groupinner = group.group().translate(shape.isHorizontal ? 0 : fretLabelWidth, shape.isHorizontal ? fretLabelWidth : 0);

    if (shape.isChord && shape.stringBarRange) {
        let fretRangeXMin = stringSidePadding + spaceBetweenStrings * shape.stringBarRange.fromString;
        let fretRangeXMax = stringSidePadding + spaceBetweenStrings * shape.stringBarRange.toString;
        let fretRangeY = fretBoardTopPadding + spaceBetweenFrets * (shape.stringBarRange.fret - shape.firstStringPositions[0] + 0.5) - noteRadius;
        groupinner.rect(fretRangeXMax - fretRangeXMin, noteRadius * 2).attr({
            x: fretRangeXMin,
            y: fretRangeY,
            opacity: 0.25,
        });
    }

    for (const [index] of Object.entries(shape.stringsSerialized)) {
        let currentStringWidth = stringWidths[index] * stringWidthCoefficient;
        let currentStringHeight = stringHeight;

        let currentStringX = stringSidePadding + spaceBetweenStrings * index - 0.5 * currentStringWidth;
        let currentStringY = 0;

        groupinner.rect(shape.isHorizontal ? currentStringHeight : currentStringWidth, shape.isHorizontal ? currentStringWidth : currentStringHeight).attr({
            x: shape.isHorizontal ? currentStringY : currentStringX,
            y: shape.isHorizontal ? currentStringX : currentStringY,
        });
    }

    relativeFretIndex = 0;

    let firstStringFrets = shape.firstStringPositions.concat(shape.firstStringPositions[shape.firstStringPositions.length - 1] + 1);
    firstStringFrets.forEach(function (absoluteFretIndex) {
        if (absoluteFretIndex >= 1) {
            let currentFretWidth = fretBoardWidth;
            let currentFretHeight = absoluteFretIndex >= 2 ? fretHeight : 2 * fretHeight;

            let currentFretX = 0;
            let currentFretY = fretBoardTopPadding + spaceBetweenFrets * relativeFretIndex - 0.5 * fretHeight;

            groupinner.rect(shape.isHorizontal ? currentFretHeight : currentFretWidth, shape.isHorizontal ? currentFretWidth : currentFretHeight).attr({
                x: shape.isHorizontal ? currentFretY : currentFretX,
                y: shape.isHorizontal ? currentFretX : currentFretY,
            });
        }

        ++relativeFretIndex;
    });

    for (const [index, positions] of Object.entries(shape.stringsSerialized)) {
        relativeFretIndex = 0;
        for (const [absoluteFretIndex, position] of Object.entries(positions)) {
            let circleCenterX = stringSidePadding + spaceBetweenStrings * index;
            let circleCenterY = fretBoardTopPadding + spaceBetweenFrets * (relativeFretIndex + 0.5);

            let noteColor = position.isRootNote ? 'red' : 'black';
            let noteText = position.finger ? position.finger : position.note;

            if (position.isPlayed) {
                const noteGroup = groupinner.group().translate(shape.isHorizontal ? circleCenterY : circleCenterX, shape.isHorizontal ? circleCenterX : circleCenterY);
                noteGroup.click(function () {
                    const midiNote = getMidiNoteForSemitone(position.semitone);
                    playMidiNotes([midiNote]);
                }).attr('cursor', 'pointer');

                const noteCircleNode = noteGroup.circle().radius(noteRadius);

                const noteTextNode = noteGroup.plain(noteText).attr({
                    'dominant-baseline': 'central',
                    'text-anchor': 'middle',
                }).font({
                    size: noteTextSize,
                    family: '',
                });

                if (absoluteFretIndex >= 1) {
                    noteCircleNode.fill(noteColor);
                    noteTextNode.fill('white');
                } else {
                    noteCircleNode.fill('white').stroke({
                        color: noteColor,
                        width: 1.5,
                    });
                    noteTextNode.fill('black');
                }
            }

            ++relativeFretIndex;
        }
    }


    if (shape.isChord) {
        for (const [index, position] of Object.entries(shape.playedPositionsSerialized)) {
            let circleCenterX = stringSidePadding + spaceBetweenStrings * index;
            let circleCenterY = stringHeight + stringNoteHeight / 2;

            let noteText = 'X';
            let noteColor = 'lightgrey';

            if (position !== null) {
                noteText = position.note;
                noteColor = position.isRootNote ? 'red' : 'black';
            }

            groupinner.plain(noteText).fill(noteColor).attr({
                'x': shape.isHorizontal ? circleCenterY : circleCenterX,
                'y': shape.isHorizontal ? circleCenterX : circleCenterY,
                'dominant-baseline': 'central',
                'text-anchor': 'middle',
            }).font({
                size: playedNotesTextSize,
                family: '',
                weight: 'bold',
            });
        }
    }
}


// https://en.wikipedia.org/wiki/General_MIDI
const instrumentName = 'acoustic_guitar_steel';

// eslint-disable-next-line no-unused-vars
export function playMidiNotes(midiNotes) {
    getInstrument().then(function (soundfont) {
        //soundfont.instrument.stop();

        var scheduledNotes = midiNotes.map(function (midiNote, i) {
            return {time: 0.4 * i + 0.5, note: midiNote};
        });
        soundfont.instrument.schedule(soundfont.audioContext.currentTime, scheduledNotes);
    });
}

// eslint-disable-next-line no-unused-vars
export function playMidiChord(midiNotes) {
    getInstrument().then(function (soundfont) {
        //soundfont.instrument.stop();

        var scheduledNotes = midiNotes.map(function (midiNote, i) {
            return {time: 0, note: midiNote};
        });
        soundfont.instrument.schedule(soundfont.audioContext.currentTime, scheduledNotes);
    });
}

var instrumentPromise;

let audioContext;

// See also https://github.com/pavle-goloskokovic/web-audio-touch-unlock
function resumeAudioContext() {
    audioContext = audioContext || new (window.AudioContext || window.webkitAudioContext)();
    if (audioContext.state === 'suspended') {
        audioContext.resume().then(function () {
            // Audio context was resumed
        }, function (reason) {
            console.error('Unable to resume audio context', reason);
        });
    }
}

function getInstrument() {
    resumeAudioContext();

    if (!instrumentPromise) {
        instrumentPromise = instrument(audioContext, instrumentName);
    }

    return new Promise(function (resolutionFunc) {
        instrumentPromise.then(function (instrument) {
            resolutionFunc({instrument: instrument, audioContext: audioContext});
        });
    });
}
